import { english } from "./englishMessages";

export const spanish: typeof english = {
  header: {
    buttons: {
      signIn: "Iniciar sesión",
      getPricing: "Agendar demo",
      benefits: "Beneficios",
      services: "Servicios",
      forDevelopers: "Para desarrolladores",
      product: "Producto",
      customers: "Clientes",
    },
  },
  sections: {
    customers: {
      our: "¡Nuestras ",
      successStories: "Historias de Éxito!",
    },
    aboutUs: {
      formA: {
        title: "¡Impulsa tu ",
        title2: "gestión en la nube!",
        subtitle: "Transforma tu infraestructura en minutos. ",
        bold1:
          "Optimiza, ahorra y protege tus datos con nuestra escalabilidad y seguridad.",
        button: "Hablar con un experto",
      },
      formB: {
        title: "Protege y optimiza tu ",
        title2: "infraestructura en la nube",
        subtitle:
          "Asegura tus recursos en la nube con tecnología confiable, mientras <b>optimizas los costos</b> para maximizar la <b>eficiencia</b> y la <b>seguridad.</b>",
        button: "Quiero más información",
      },
      input: "Correo electrónico ",
      button: "Contactar un experto",
    },
    benefits: {
      title1: "Conoce las ventajas",
      title2: "de una",
      title3: "infraestructura de alto rendimiento",
      benefitsItems: {
        item1: {
          copy1: "Conecta tu ",
          copy2: "cuenta en la nube",
        },
        item2: {
          copy1: "Capacidades de ",
          copy2: "soporte ",
          copy3: "ampliadas",
        },
        item3: {
          copy1: "Maximiza la rentabilidad",
        },
        item4: {
          copy1: "Ahorra en los costos ",
          copy2: "de los servicios de AWS",
        },
        item5: {
          copy1: "Acelera el tiempo ",
          copy2: "de entrada al mercado",
        },
        item6: {
          copy1: "Fomenta la innovación",
        },
      },
    },
    metrics: {
      title1: "Nuestros números",
      title2: "cuentan más",
      title3: "",
      title4: "sobre nosotros",
      items: {
        databases: "Base de datos",
        instances: "Instancias",
        deploys: "Despliegues",
        services: "Servicios",
      },
    },
    users: {
      title1: "Nuestros clientes son empresas de alto",
      title2: " crecimiento en todo el mundo",
    },
    services: {
      title1: "Construye de manera ágil utilizando nuestros servicios de ",
      title2: "infraestructura tecnológica",
      domains: {
        title: "Dominios",
        paragraph: "Vincula dominios y certificados sin esfuerzo.",
      },
      environments: {
        title: "Entornos",
        paragraph:
          "Crea múltiples entornos para cada servicio, asegurando la seguridad, escalabilidad y evolución de tu arquitectura.",
      },
      backend: {
        title: "Backend",
        paragraph:
          "Garantizamos una operación eficiente y escalable al gestionar y procesar datos, junto con la lógica y funcionalidad del lado del servidor. Nuestra plataforma utiliza recursos poderosos como HTTPS, programación de tareas, workers y lambdas para garantizar un rendimiento óptimo.",
      },
      resources: {
        title: "Recursos",
        paragraph:
          "Crea y gestiona recursos sin esfuerzo, como bases de datos (RDS), compartimientos de almacenamiento (S3), redes virtuales privadas, sistema de archivos elástico (EFS), DocumentDB, Postgres, MySQL, Kafka (3MSK), OpenSearch y más.",
      },
      frontend: {
        title: "Desarrollo de Front-end",
        paragraph:
          "Configura e implementa interfaces sin esfuerzo con cualquier lenguaje de programación.",
      },
    },
    languages: {
      title1: "Lenguajes y frameworks para un desarrollo sencillo",
    },
    howItWorks: {
      title1: "Simplifica la configuración de tu infraestructura en AWS y",
      title2: "construye un proceso de DevSecOps más rápido para tu",
      title3: "organización",
      items: {
        item1: "Configura tu entorno",
        item2: "Configura tus servicios de Backend",
        item3: "Configura tus recursos",
        item4: "Configura tus servicios de frontend",
      },
    },
    architectures: {
      title1: "La arquitectura",
      title2: " que puedes crear",
      copy1: "Puedes aprovechar los servicios mencionados para construir desde",
      monoliths: " monolitos ",
      to: "hasta ",
      microservicesBased: "arquitecturas basadas en microservicios",
      and: " y ",
      serverless: " Serverless.",
    },
  },
  footer: {
    copies: {
      allRightsReserved: "© 2022 Cactus.cloud. All right reserved.",
      poweredBy: "Powered by",
      contactUs: "Contáctenos",
    },
  },
  forDevelopers: {
    title: "Explora las últimas novedades y",
    lastesArticles: " Últimos artículos",
    colorTitle: "tendencias de la industria",
    youMayAlso: "También te puede interesar",
    langAdvice1: "Este blog está en otro idioma. ",
    langAdvice2: "¿Te gustaría navegarlo en tu idioma actual?",
    readMore: "Leer más",
    suscribeTo: "Suscríbete a ",
    ourBlog: "nuestro blog",
    email: "Correo electrónico",
    stayUpdateWithTheLatest:
      "Mantente actualizado con las últimas novedades en infraestructura en la nube.",
    suscribeNow: "Suscríbete ahora",
  },
  customers: {
    our: "¡Nuestras",
    customerSuccessStories: "<span>Historias de éxito</span> de clientes",
    boostEfficiencyOptimizeExpensesAnd:
      "Aumenta la eficiencia, optimiza los gastos y maximiza el potencial de tu empresa.",
    contactAnExpert: "Contacta un experto",
    start: "Comienza a ",
    optimizingYourGoals: "optimizar tus objetivos",
    withC4c7us: " con Cactus.cloud",
    contactUs: "Contact us",
    viewMoreInformation: "Ver más información",
    doYouWantToBe:
      "¿Quieres ser una de nuestras historias de éxito? ¡Regístrate ahora! ",
    bookADemo: "Agenda una demo",
    freeYourselfFromTheComplications: "Libérate de complicaciones",
    joinNowToEnhanceYour: "Únete ahora para mejorar tu eficiencia.",
    simplifyYourItManagementAnd:
      "Simplifica la gestión de tu IT y ahorra en la nube. ",
    viewSuccessStory: "Ver historia de éxito",
    previous: "Anterior",
    next: "Siguiente",
    keyAreasWhere: "Áreas clave en las que ",
    weAssistOurClients: "ayudamos a nuestros clientes",
    keyAreas: {
      databases: "Databases",
      devops: "DevOps",
      securityManagement: "Security Management",
      finOps: "FinOps",
      iot: "IoT",
      sre: "SRE",
      dba: "DBA",
      secOps: "SecOps",
    },
    successStoriesBottomBanner: {
      freeYourselfFromComplications: "Libérate de las complicaciones.",
      simplifyYourItManagementAnd:
        "Simplifica la gestión de tu TI y ahorra en la nube. ",
      joinNowToEnhanceYour: "Únete ahora para mejorar tu eficiencia.",
      contactAnExpert: "Contacta a un experto.",
    },
    copies: {
      bia: {
        category: "Energía",
        body: "Es una plataforma líder en la comercialización digital de energía eléctrica, ofreciendo a los consumidores un control preciso y en tiempo real sobre su consumo, garantizando una monitorización confiable. Con el apoyo de Cactus.cloud,  Bia ha alcanzado mayores niveles de eficiencia y gestión de recursos, garantizando un servicio estable en áreas clave como DevOps, SRE, DBA y SecOps. Además, han logrado mejoras significativas en tres áreas clave: Velocidad de implementación, optimización de costos y operatividad del negocio.",
      },
      elenas: {
        category: "E-commerce",
        body: "Ellos son una plataforma digital que está revolucionando el comercio social en América Latina. Con Elenas, cientos de miles de mujeres en Colombia y México han lanzado negocios en línea, asegurando ingresos adicionales al vender productos en plataformas de redes sociales como WhatsApp y Facebook...",
      },
      sumer: {
        category: "E-commerce",
        body: "Startup de comercio electrónico que brinda a sus usuarios la oportunidad de comprar y vender productos en línea. Con Cactus.cloud, han logrado avances significativos en áreas clave como DevOps, SRE, DBA y SecOps, lo que les ha permitido optimizar sus recursos y costos de manera más eficiente y exitosa.",
      },
      datup: {
        category: "Servicios e tecnologías de la información",
        body: "Datup es una herramienta digital que revoluciona la gestión de datos empresariales. Con su implementación de inteligencia artificial, ayuda a las empresas a lograr ahorros significativos en la cadena de suministro y en sus procesos de adquisición. Con el apoyo de Cactus.cloud, han logrado estabilidad en la infraestructura, asegurando un rendimiento óptimo.",
      },
      dapta: {
        category: "Tech",
        body: "Es una plataforma no-code para Backend y APIs. Permite a los usuarios integrar múltiples fuentes de datos, crear herramientas internas según la lógica de negocio y desarrollar APIs con un no-code builder. Con Cactus.cloud han logrado mejorar la estabilidad de su infraestructura y garantizar un funcionamiento óptimo de su plataforma.",
      },
      vammo: {
        category: "Ingeniería de Movilidad Eléctrica",
        body: "Vammo brinda servicios de alquiler de motos eléctricas e intercambio de baterías. Al usar Cactus.cloud, han logrado mantener una operación confiable y garantizar una experiencia sin problemas para sus clientes.",
      },
      rurral: {
        category: "AgroTech",
        body: "Conecta a los pequeños agricultores con los mercados a través de su canal digital. Con Cactus.cloud han logrado gestionar eficientemente su infraestructura tecnológica en la parte de DevOps. Esta solución les ha proporcionado flexibilidad y agilidad para adaptarse a las demandas cambiantes del mercado y satisfacer las necesidades de sus usuarios de manera efectiva.",
      },
      linnda: {
        category: "SaaS",
        body: "Son una herramienta de análisis de datos plug and play con énfasis en retención y análisis de cohortes, ideal para marcas que desean comprender mejor a sus clientes y mejorar su crecimiento. Con Cactus.cloud, han logrado garantizar un funcionamiento óptimo de su plataforma.",
      },
      tuulapp: {
        category: "Desarrollo de software",
        body: "Son una plataforma digital que revoluciona la gestión de talleres de reparación de automóviles, transformando la forma en que los talleres operan. Proporcionan herramientas innovadoras para optimizar cada aspecto de la administración, asegurando una operación más eficiente. Gracias al apoyo de Cactus.cloud, han logrado una estabilidad constante en la infraestructura...",
      },
      subagan: {
        category: "AgroTech",
        body: "Facilitan espacios donde oferentes y demandantes de semovientes y diversos bienes transables encuentren las mejores condiciones de mercado para comercializar sus productos. Con Cactus.cloud, han logrado tener una estabilidad en su infraestructura, optimizar costos y recursos. Fortaleciendo aún más su infraestructura y capacidad operativa",
      },
      docokids: {
        category: "Telemedicina",
        body: "Son una plataforma digital que transforma el cuidado pediátrico. Con esta herramienta, los usuarios pueden hacer preguntas a pediatras las 24 horas del día, los 7 días de la semana, a través de WhatsApp. Con el apoyo de Cactus.cloud en el área de DevOps, han mejorado la estabilidad de su infraestructura y asegurado un rendimiento óptimo, garantizando una experiencia fluida y accesible para sus usuarios en todo momento.",
      },
      pontelabor: {
        category: "Dotación y selección de personal",
        body: "Marketplace innovador que está transformando la industria hotelera en EE. UU., al conectar a inmigrantes hispanos con oportunidades en hoteles y restaurantes. Con Cactus.cloud han logrado fortalecer y escalar su infraestructura de manera óptima. ",
      },
      nebula: {
        category: "Desarrollo de software",
        body: "Servicios de transporte de pasajeros de alta calidad. Con Cactus.cloud, han logrado mejorar la eficiencia de su plataforma, focalizándose en la optimización de costos y recursos en la parte de DevOps.",
      },
      nibi: {
        category: "Desarrollo de software",
        body: "Son la primera plataforma digital que está revolucionando la manera de hacer labor social en Latinoamérica. Con Cactus.cloud han logrado mejorar la estabilidad en su infraestructura, garantizando un funcionamiento óptimo de su plataforma.",
      },
    },
    developers: {
      "jyfer-bia":
        "Cactus.cloud ha sido un aliado estratégico desde el principio, brindándonos la velocidad y confiabilidad necesarias. Se ha adaptado a nuestras necesidades y se ha convertido en una plataforma clave para nuestro crecimiento.",
      "romel-palomino-bia":
        "Como VP de Ingeniería en Bia, he trabajado con Cactus.cloud y su plataforma ha tenido un impacto positivo. Gracias a su colaboración, administramos nuestra infraestructura de manera eficiente. <br/><br/>Su solución ágil y segura nos permite controlar nuestros recursos tecnológicos, ahorrar y enfocar a nuestro equipo en nuestro negocio principal. Estamos agradecidos por su colaboración y apoyo en nuestro éxito.",
      "oscar-sumer":
        "Como cofundador de Sumer, afirmo que nuestra asociación con Cactus.cloud ha sido vital. Gracias a su sólida infraestructura y apoyo integral, nos hemos centrado en mejorar nuestro producto para pymes. <br></br>  Cactus.cloud ofrece una plataforma confiable, seguridad, asesoramiento en costos y un equipo de soporte excepcional. Recomendamos a Cactus a cualquier startup en busca de un socio tecnológico confiable y exitoso.",
      "daniel-ordones-dapta":
        "La verdad estamos muy contentos con Cactus.cloud, ha cumplido 100% con la propuesta de valor y nos ahorra un montón de tiempo en despliegues de microservicios, además hemos tenido un soporte espectacular.",
      "jairo-miranda-vammo":
        "Nuestra experiencia con Cactus.cloud ha sido excepcional desde el principio. Su plataforma simplifica radicalmente la gestión de nuestra infraestructura tecnológica, permitiéndonos configurar y escalar nuestros sistemas con una facilidad impresionante. El asesoramiento experto de Cactus.cloud no solo ha optimizado nuestros procesos, sino que también ha sido clave para ahorrar costos. <br/> Gracias a Cactus.cloud, podemos enfocarnos en innovar y crecer, confiando en que nuestra infraestructura está en buenas manos.",
      "yahir-nader-subagan":
        "Querer invertir tiempo que ocupas en tus servers en otras actividades? Si, eso me paso con Cactus.cloud delegar las responsabilidad del dia a día en las mejores manos de expertos capacitados.<br/><br/> Desde Subagan estamos muy satisfechos con la herramienta, desde la atención al cliente como en tiempo de respuetas ante cualquier adversidad. 100% contentos con ustedes.",
      "carlos-sanchez-sumer":
        "Gracias a Cactus.cloud, como desarrollador de una startup, me libero de las complejidades de la infraestructura en la nube. <br/><br/>Ahora puedo enfocarme en nuestros clientes, lanzar nuevos servicios y funcionalidades con facilidad, lo que hace mi trabajo más productivo y centrado.",
      "natalia-roa-nibi":
        "Con cactus tenemos la tranquilidad de una infraestructura unificada y estable, con agilidad de despliegue y flexibilidad en el alcance. <br/><br/>Gracias a ello podemos concentrar nuestros esfuerzos en el desarrollo sin preocuparnos por el tiempo que invertiríamos en infraestructura.",
      "jeremy-bolaños-nebula":
        "Mi experiencia en cactus ha sido de maravilla Los despliegues se realizan de manera fácil, ágil e intuitiva. <br/><br/> El soporte que recibimos es rápido y asertivo, se nota el compromiso por parte de su equipo.",
      "javier-vasquez-rurral":
        "Desde que Cactus.cloud es nuestro aliado, en Rurall, hemos experimentado una transformación en la administración de nuestra infraestructura tecnológica. Gracias a su interfaz intuitiva y sus capacidades de gestión, ahora podemos optimizar nuestros recursos, mejorar la eficiencia operativa y garantizar la disponibilidad de nuestros servicios. <br/><br/> Cactus.cloud ha sido un excelente socio para impulsar el crecimiento y la competitividad de nuestra empresa en el mercado digital actual",
      "rafael-casabianca-linnda":
        "En nuestra experiencia, Cactus ha sido fundamental para agilizar la construcción de nuestra infraestructura y su posterior lanzamiento a producción. <br/><br/> Nos ha permitido ahorrar recursos en la nube y nos ha facilitado la formación de un equipo especializado. Estamos realmente satisfechos con el excelente soporte al cliente que nos ofrecen.",
      "santiago-rodriguez-vammo":
        "Cactus.cloud ha transformado nuestra experiencia digital con su interfaz simple y eficiente, conectando nuestra infraestructura con nuestros proyectos. <br/><br/>Su equipo destaca por su profesionalismo, amabilidad y compromiso con la mejora continua, lo que ha mejorado significativamente la eficiencia de nuestros proyectos.",
      "ramiro-chaparro-datup":
        "Desde que contratamos los servicios de administración delegada de Cactus, hemos recibido un acompañamiento técnico excepcional. Su equipo, con profundo conocimiento y un enfoque proactivo, no solo resuelve problemas sino que también anticipa y previene inconvenientes, permitiéndonos optimizar nuestras operaciones y enfocarnos en nuestro negocio principal. Cactus ha superado nuestras expectativas, convirtiéndose en un aliado estratégico para nuestra startup.",
      "german-palacios-elenas":
        "Nuestra experiencia con el equipo de Cactus.cloud ha sido excepcional. Nos han apoyado como parte del equipo de tecnología, trabajando de la mano con nosotros. El proceso de onboarding fue bastante simple y en un muy corto tiempo comenzamos a trabajar en mejoras y modificaciones a nuestra infraestructura. Los tiempos de respuesta han sido excelentes y nos han permitido enfocar nuestro proceso de desarrollo en elementos claves para nuestra organización confiando en que tenemos un soporte confiable y robusto en la administración de nuestra infraestructura.",
      "juan-aranguren-vammo":
        "4c7us ha sido un aliado técnico clave desde el primer día de operaciones en Vammo.<br/><br/> Lo que inició como un monolito de funciones básicas en nuestra empresa, y hoy en día integra microservicios, comunicaciones con hardware, analítica y otras herramientas, fue posible gracias a los servicios y excelente soporte ofrecidos por el equipo de Cactus.cloud. Lograron transformar las tareas de infraestructura en algo sencillo y escalable, permitiéndole a nuestro equipo de software, trabajar desarrollando software, a medida que acortamos mucho nuestros ciclos de despliegue y levantamiento de nuevos recursos.",
      "natalia-cano-docokids":
        "Nuestra experiencia con Cactus.cloud ha sido sumamente positiva. Desde que comenzamos a trabajar en conjunto, sus servicios de infraestructura tecnológica han transformado nuestra manera de gestionar y escalar nuestros sistemas en AWS. La agilidad que Cactus.cloud aporta en la configuración de nuestra infraestructura y en la implementación de un proceso de DevOps ha sido invaluable para Docokids.<br/><br/>La simplicidad con la que podemos ahora manejar nuestra infraestructura nos ha permitido enfocarnos en lo que realmente importa: innovar y ofrecer un mejor servicio a nuestros clientes. Además, el asesoramiento experto de Cactus.cloud ha sido clave para optimizar nuestros procesos y reducir costos operativos.<br/><br/>Con Cactus.cloud a nuestro lado, confiamos plenamente en que nuestra infraestructura tecnológica está bien gestionada, lo que nos da la libertad de crecer y evolucionar con confianza. Recomendamos a Cactus.cloud a cualquier empresa que busque una solución efectiva y eficiente para su infraestructura tecnológica.",
    },
  },
  product: {
    costOptimization: {
      costOptimization: "Optimización de costos",
      inTheCloud: "en la nube",
      cost: "Monitoreo",
      monitoring: "de costos",
      keepingYourCostsUnderControl:
        "Mantener sus costos bajo control y su infraestructura funcionando de manera óptima. Por eso ofrecemos un sistema de monitoreo integral que le permite mantenerse informado sobre sus gastos en la nube y recibir alertas inmediatas en caso de incidentes que puedan afectar su presupuesto o la disponibilidad del servicio.",
    },
    monitoringAndTraceability: {
      monitoring: "Monitoreo",
      andTracing: "y rastreo",
      totalVisibilityAndPreciseTracking:
        "Visibilidad total y seguimiento preciso: ofrecemos una solución integral de monitoreo y rastreo para su infraestructura web. Con nuestro sistema avanzado, obtenga una vista completa del rendimiento de sus aplicaciones y servidores.",
    },
    headerItems: {
      costOptimizationInTheCloud: "Optimización de costos en la nube",
      security: "Seguridad",
      infrastructureManagement: "Administración de infraestructura",
    },
    headerSubItems: {
      costMonitoring: "Monitoreo de Costos",
      monitoringAndTraceability: "Monitoreo y trazabilidad",
      rolesAndPermissions: "Roles y permisos",
      policyConfiguration: "Configuración de políticas",
      infrastructure: "Infraestructura",
      vpnsSupport: "Compatibilidad con VPN",
      assistanceInArchitectureAndPerformanceImprovements:
        "Asistencia en mejoras de arquitectura y rendimiento",
      securitySupport: "Apoyo en seguridad",
      autoscaling: "Autoscaling",
      logs: "Logs",
      reportingAndOptimization: "Reportes y optimización",
      implementationOfActionableMeasuresForCostOptimization:
        "Implementación de medidas para la optimización de costos",
      cicdDeployment: "CI/CD",
      deploymentControl: "Control de implementación",
      supportedServices: "Servicios compatibles",
      dataops: "DataOps",
    },
    security: "Seguridad",
    rolesAndPermissions: {
      rolesAnd: "Roles ",
      permissions: "y permisos",
      manageAccessAndProtectYourData:
        "Entendemos la importancia de mantener un control granular sobre quién accede y qué acciones pueden realizar en su plataforma. Nuestra solución de gestión de roles y permisos ofrece la flexibilidad y seguridad necesarias para gestionar eficazmente el acceso y proteger sus datos críticos.",
    },
    policyConfiguration: {
      policy: "Configuración",
      Configuration: "de políticas",
      setUpPoliciesToEfficiently:
        "Establezca políticas para controlar eficientemente el acceso a servicios clave. Nuestra plataforma le permite definir configuraciones de políticas personalizadas para garantizar un acceso seguro y sin complicaciones a servicios como DynamoDB y otros.",
    },
    infrastructure: {
      infrastructure: "Infraestructura",
      aSolidInfrastructureIsTheFoundation:
        "Una infraestructura sólida es la base de cualquier aplicación exitosa. Es por eso que ofrecemos una solución integral de gestión de infraestructura que le permite construir, monitorear y mantener sus servicios de manera eficiente y sin complicaciones.",
    },
    vpnsSupport: {
      vpnsSupport: "Compatibilidad con VPNs",
      maintainTheSecurityAndPrivacy:
        "Mantenga la seguridad y privacidad de sus datos en todo momento. Es por eso que ofrecemos un soporte VPN integral para garantizar una conexión segura y confiable a sus recursos en la nube.",
    },
    assistanceInArchitectureAndPerformanceImprovements: {
      assistanceInArchitectureAnd: "Asistencia en arquitectura ",
      performanceImprovements: "y mejoras de rendimiento",
      weEnsureThatYourInfrastructureIsInTopShape:
        "¡Nos aseguramos de que su infraestructura esté en óptimas condiciones para ofrecer el mejor rendimiento! Nuestro equipo de expertos en arquitectura y rendimiento está aquí para brindar orientación y apoyo en cada paso del camino. Trabajamos juntos para que pueda alcanzar sus objetivos de manera eficiente ¡y con una sonrisa!",
    },
    securitySupport: {
      security: "Apoyo en ",
      support: "seguridad",
      weOfferAPlatformDesignedTo:
        "Ofrecemos una plataforma diseñada con tecnología de vanguardia y prácticas de seguridad líderes en la industria. Desde la autenticación de usuarios hasta la prevención de amenazas cibernéticas.",
    },
    infrastructureTitle: "Administración de ",
    management: "Infraestructura",
    autoscaling: {
      autoscaling: "Autoscaling",
      cactusOffersYouTheFlexibility:
        "Cactus.cloud te ofrece la flexibilidad de ajustar automáticamente tu infraestructura para fechas de alto tráfico, como eventos especiales o lanzamientos de productos. Con el escalado automático programado, tu aplicación estará lista para manejar cualquier carga de trabajo, garantizando un rendimiento óptimo durante momentos críticos.",
    },
    logs: {
      logs: "Logs",
      accessDetailedLogsOfAllActivities:
        "Acceda a registros detallados de todas las actividades en su infraestructura web en tiempo real. Monitoree cada paso, desde el despliegue de aplicaciones hasta el rendimiento del servidor, lo que le permite identificar y resolver problemas rápida y eficientemente.",
    },
    reportingAndOptimization: {
      reportingsAnd: "Reportes y ",
      optimization: "optimización",
      weOfferAComprehensiveReporting:
        "Ofrecemos una solución integral para reportes y optimización de costos, brindándole información detallada sobre sus gastos y recomendaciones específicas para reducir costos innecesarios y maximizar el valor de su infraestructura.",
    },
    implementationOfActionable: {
      implementationOfActionable: "Implementación de ",
      measuresForCostOptimization: "medidas para la optimización de costos",
      weHaveComprehensiveCostReporting:
        "Contamos con una solución integral de reporte y optimización de costos que proporciona información detallada sobre sus gastos y recomendaciones específicas para reducir costos innecesarios y maximizar el valor de su infraestructura.",
    },
    CICD: {
      CICD: "CI/CD",
      speedUpTheDevelopmentAndDeployment:
        "Acelere el proceso de desarrollo e implementación de sus aplicaciones. Nuestra plataforma ofrece una solución integral de CI/CD (Integración Continua/Entrega Continua) que automatiza todas las fases del ciclo de vida de desarrollo, desde la construcción y prueba hasta la implementación en producción.",
    },
    deploymentControl: {
      deployment: "Control de ",
      control: "implementación",
      executeYourDeploymentsAndHave:
        "Ejecute sus implementaciones y tenga control sobre ellas monitoreando los registros de instancias y los gráficos de implementación. De esta manera, puede garantizar el control y la seguridad en cada una de sus implementaciones.",
    },
    supportedServices: {
      supported: "Servicios ",
      services: "compatibles",
    },
    dataOps: {
      data: "Data",
      ops: "Ops",
      monitoringAndObservability: "Monitoreo y observabilidad",
      performanceOptimization: "Optimización de performance",
      dataSecurity: "Seguridad de datos",
      analysisAndReporting: "Análisis y reportes",
      proactiveMonitoringAndRealTime:
        "Monitoreo proactivo y dashboards en tiempo real.",
      dataPerformanceAndOptimization:
        "Optimización del rendimiento de datos y prácticas CI/CD con pruebas automatizadas.",
      designOfAutomatedETL:
        "Diseño de pipelines ETL/ELT automatizados y uso de DataOps.",
      continuousIntegrationOfDataFrom:
        "Integración continua de datos de múltiples fuentes con APIs y conectores.",
      governancePoliciesForQuality:
        "Políticas de gobernanza para calidad, seguridad y cumplimiento.",
      toolsForDataCatalogingLineage:
        "Herramientas para catalogación, linaje y cifrado de datos, y gestión de accesos.",
      creationOfCustomReportsAnd:
        "Creación de reportes y dashboards personalizados.",
      realTimeDataAnalysisAnd:
        "Análisis de datos en tiempo real y modelos predictivos.",
    },
  },
  earlyAccess: {
    bookA: "Consultar un",
    demo: "experto",
    requestADemoAndDiscoverHow:
      "Contáctenos para recibir una asesoría gratuita y descubre cómo podemos mejorar la seguridad y escalabilidad mientras ahorras costos. Consulta con nosotros para comenzar y enfocarte en hacer crecer tu negocio.",
    focusOnGrowingYourBusiness: "enfocarte en hacer crecer tu negocio.",
    costSaving: "Ahorro de costos:",
    saveCostsWhileEnhancing:
      "Ahorra costos mientras mejoras la seguridad y escalabilidad para tu negocio con nuestra solución.",
    limitlessScalability: "Escalabilidad ilimitada:",
    easilyScaleYourInfrastructure:
      "Escala fácilmente tu infraestructura para que coincida con el crecimiento de tu negocio sin ninguna restricción.",
    secureDataProtection: "Protección segura de datos:",
    restAssuredKnowingYourData:
      "Descansa tranquilo sabiendo que tus datos están protegidos con medidas de seguridad de última generación, garantizando tranquilidad en cada paso del camino.",
  },
  privacyAdvice: {
    weUseCookiesToEnhanceYour: `Usamos cookies para mejorar su experiencia en nuestro sitio y personalizar el contenido a sus necesidades. Al hacer clic en "Aceptar", usted acepta. Lea nuestra `,
    cookiePolicy: "Política de Cookies",
    and: " y nuestra ",
    privacyAndDataPolicy: "Política de Privacidad y Datos",
    forMoreInformation: " para más información.",
    acceptAllCookies: "Aceptar todas las cookies",
  },
  currentLanguage: "es",
};
